import { ConstantFormat, DateFns } from "../../../../../../../utils/DateFns";

import type { Order } from "../../../../../../../services";

const cellProcessing = (item?: Order.Model, dateFns?: DateFns) => {
	if (!item || !dateFns) return "";

	const content = item?.closedAt
		? dateFns.formatTime2(item.orderDate, ConstantFormat.MDYHM_UK, {
				timezone: dateFns.timezone,
				zeroSeconds: true,
		  })
		: "";

	return content;
};

export default cellProcessing;
